import Const from 'constants';

import {PlayersList as NBAClassicPlayersList} from 'components/organisms/used-players-list/components/mobile/players-list/sports/nba/classic';
import {PlayersList as NBASingleGamePlayersList} from 'components/organisms/used-players-list/components/mobile/players-list/sports/nba/single-game';

import {PlayersList as MLBClassicPlayersList} from 'components/organisms/used-players-list/components/mobile/players-list/sports/mlb/classic';
import {PlayersList as MLBSingleGamePlayersList} from 'components/organisms/used-players-list/components/mobile/players-list/sports/mlb/single-game';

import {PlayersList as CFBClassicPlayersList} from 'components/organisms/used-players-list/components/mobile/players-list/sports/cfb/classic';
import {PlayersList as CFBSingleGamePlayersList} from 'components/organisms/used-players-list/components/mobile/players-list/sports/cfb/single-game';

import {PlayersList as NHLClassicPlayersList} from 'components/organisms/used-players-list/components/mobile/players-list/sports/nhl/classic';
import {PlayersList as NHLSingleGamePlayersList} from 'components/organisms/used-players-list/components/mobile/players-list/game-types/single-game';

import {PlayersList as NFLClassicPlayersList} from './nfl/classic';
import {PlayersList as NFLSingleGamePlayersList} from 'components/organisms/used-players-list/components/mobile/players-list/sports/nfl/single-game';

import {
    PlayersList as GOLFPlayersList,
    PlayersList as NASCARPlayersList,
} from 'components/organisms/used-players-list/components/mobile/players-list/game-types/classic';

import {PlayersList as MMAPlayersList} from 'components/organisms/used-players-list/components/mobile/players-list/sports/mma/single-game';
import {PlayersList as LOLPlayersList} from 'components/organisms/used-players-list/components/mobile/players-list/sports/lol/classic';

const classesMap = {
    [Const.LEAGUE_CFB]: {
        [Const.GAME_TYPE_CLASSIC]: CFBClassicPlayersList,
        [Const.GAME_TYPE_SINGLEGAME]: CFBSingleGamePlayersList,
    },
    [Const.LEAGUE_GOLF]: {
        [Const.GAME_TYPE_CLASSIC]: GOLFPlayersList,
    },
    [Const.LEAGUE_LOL]: {
        [Const.GAME_TYPE_CLASSIC]: LOLPlayersList,
    },
    [Const.LEAGUE_MMA]: {
        [Const.GAME_TYPE_CLASSIC]: MMAPlayersList,
    },
    [Const.LEAGUE_MLB]: {
        [Const.GAME_TYPE_CLASSIC]: MLBClassicPlayersList,
        [Const.GAME_TYPE_SINGLEGAME]: MLBSingleGamePlayersList,
    },
    [Const.LEAGUE_NASCAR]: {
        [Const.GAME_TYPE_CLASSIC]: NASCARPlayersList,
    },
    [Const.LEAGUE_NBA]: {
        [Const.GAME_TYPE_CLASSIC]: NBAClassicPlayersList,
        [Const.GAME_TYPE_SINGLEGAME]: NBASingleGamePlayersList,
    },
    [Const.LEAGUE_NFL]: {
        [Const.GAME_TYPE_CLASSIC]: NFLClassicPlayersList,
        [Const.GAME_TYPE_SINGLEGAME]: NFLSingleGamePlayersList,
    },
    [Const.LEAGUE_NHL]: {
        [Const.GAME_TYPE_CLASSIC]: NHLClassicPlayersList,
        [Const.GAME_TYPE_SINGLEGAME]: NHLSingleGamePlayersList,
    },
};

const Factory = {
    getComponent(sportConfig) {
        const sportName = sportConfig.getSport().toLowerCase();
        const gameType = sportConfig.getGameType().toLowerCase();

        const componentClass = classesMap[sportName]?.[gameType] ?? null;

        if (componentClass === null) {
            throw new Error(`Unsupported factory for "${sportName}", "${gameType}".`);
        }

        return componentClass;
    },
};

export {Factory};
